export default __webpack_public_path__ + "static/media/dan.2046c0a0.svg";